import { useTranslation } from 'react-i18next';

import { Button, Modal } from 'antd';

import styles from './UpdatePaymentConfirmModal.module.scss';

interface UpdatePaymentMethodModalProps {
  open: boolean;
  onCancel: () => void;
  onSuccess: () => void;
}

export const UpdatePaymentConfirmModal: React.FC<
  UpdatePaymentMethodModalProps
> = ({ open, onCancel, onSuccess }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('modal.updatePaymentMethod.title')}
      open={open}
      onCancel={onCancel}
      footer={null}
      width={552}
      destroyOnHidden
    >
      <div className={styles.wrap}>
        <h2 className={styles.description}>
          {t('modal.updatePaymentMethod.description')}
        </h2>
        <div className={styles.buttonsWrapper}>
          <Button type="link" onClick={onCancel}>
            {t('common.skip')}
          </Button>
          <Button type="primary" onClick={onSuccess}>
            {t('common.updatePayment')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
